export const PRODUCTION_STAGE_CODES = [
  "pre_print",
  "coating",
  "corrugation",
  "sheet_cutting",
  "pasting",
  "casting",
  "die_cutting",
  "joining",
  "after_box_print",
  "qc",
];

export const DEFAULT_STAGE_NAMES = {
  order_received: "Order Received",
  pending_inventory: "Pending Inventory",
  inventory_fulfilled: "Inventory Fulfilled",
  ready_for_production: "Ready for Production",
  pre_print: "Pre-Print",
  coating: "Coating",
  corrugation: "Corrugation",
  sheet_cutting: "Sheet Cutting",
  pasting: "Pasting",
  casting: "Casting",
  die_cutting: "Casting",
  joining: "Joining",
  after_box_print: "After Box Print",
  qc: "QC",
  ready_for_dispatch: "Ready for Dispatch",
  dispatched: "Dispatched",
};

export const getStageDisplayName = (stageCode, fallbackName) =>
  fallbackName ||
  DEFAULT_STAGE_NAMES[stageCode] ||
  String(stageCode || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const requiresStageCompletion = (stageCode) =>
  PRODUCTION_STAGE_CODES.includes(stageCode);

export const getStageOptions = (job, stages = []) => {
  const stageMap = new Map();

  (stages || []).forEach((stage) => {
    if (!stage?.code) return;
    stageMap.set(stage.code, {
      code: stage.code,
      name: getStageDisplayName(stage.code, stage.name),
      color: stage.color,
      sequence: stage.sequence ?? Number.MAX_SAFE_INTEGER,
    });
  });

  (job?.flow_stages || []).forEach((stage, index) => {
    const code = stage?.code || stage?.stage_code;
    if (!code || stageMap.has(code)) return;
    stageMap.set(code, {
      code,
      name: getStageDisplayName(code, stage.name || stage.stage_name),
      color: stage.color,
      sequence: stage.sequence ?? index,
    });
  });

  (job?.applicable_stages || []).forEach((code, index) => {
    if (!code || stageMap.has(code)) return;
    stageMap.set(code, {
      code,
      name: getStageDisplayName(code),
      sequence: index,
    });
  });

  if (job?.current_stage && !stageMap.has(job.current_stage)) {
    stageMap.set(job.current_stage, {
      code: job.current_stage,
      name: getStageDisplayName(job.current_stage, job.current_stage_name),
      color: job.stage_color,
      sequence: Number.MAX_SAFE_INTEGER - 1,
    });
  }

  return [...stageMap.values()].sort((a, b) => a.sequence - b.sequence);
};

export const getSkippedStageNames = (stageOptions, fromStage, toStage) => {
  const fromIdx = stageOptions.findIndex((stage) => stage.code === fromStage);
  const toIdx = stageOptions.findIndex((stage) => stage.code === toStage);

  if (fromIdx === -1 || toIdx === -1 || toIdx <= fromIdx + 1) {
    return [];
  }

  return stageOptions.slice(fromIdx + 1, toIdx).map((stage) => stage.name);
};
